import 'babel-polyfill'



// WEBPACK FOOTER //
// ./globals.js